import React, { Component } from "react";
import { v1 as uuid } from "uuid";
import { message, Modal } from 'antd';
import { db, auth } from '../../config/fire';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy } from '@fortawesome/free-solid-svg-icons'
import { Form, Button, Tab, Tabs } from "react-bootstrap";
import {
    CreateRoomTab,
    // Profile, ProfileSection 
} from '../../helpers/styles';
import { ModalButton } from './styles';
import Loader from "../Loader";
import { roomid } from "../../helpers/roomid";

export default class CreateMeetModal extends Component {


    constructor(props) {


        super(props);
        document.title = "Create Meet"
        var today = new Date();
        var today_hours = today.getHours();
        var today_mins = today.getMinutes();
        var today_date = today.getDate();
        var today_month = today.getMonth() + 1; //As January is 0.
        var today_year = today.getFullYear();
        if (today_hours < 10) today_hours = '0' + today_hours;
        if (today_mins < 10) today_mins = '0' + today_mins;
        var today_time = today_hours + ':' + today_mins;
        console.log(today_time);

        if (today_date < 10) today_date = '0' + today_date;
        if (today_month < 10) today_month = '0' + today_month;
        var currentDate = today_year + '-' + today_month + '-' + today_date;
        this.state = {
            user: auth().currentUser,
            error: '',
            checked: false,
            schecked: false,
            title: '',
            stitle: '',
            id: roomid(),
            tdate: currentDate,
            ttime: today_time,
            dtime: today_time,
            ddate: currentDate,
            today: false,
            allowuser: [],
            sallowuser: [],
            allowu: '',
            loading: true,
            sallowu: '',
            uchecked: false,
            suchecked: false,
        }
        this.createnow = this.createnow.bind(this);
        this.schedule = this.schedule.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handlecheck = this.handlecheck.bind(this);
        this.shandlecheck = this.shandlecheck.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);

        this.shandleKeyPress = this.shandleKeyPress.bind(this);
        this.handleuserinp = this.handleuserinp.bind(this);

        this.shandleuserinp = this.shandleuserinp.bind(this);

        this.uhandlecheck = this.uhandlecheck.bind(this);
        this.suhandlecheck = this.suhandlecheck.bind(this);
    }

    componentDidMount() {
        this.setState({
            loading: false,
        })
    }

    shandlecheck() {
        this.setState({
            schecked: !this.state.schecked
        })


    }

    handlecheck() {
        this.setState({
            checked: !this.state.checked
        })



    }
    suhandlecheck() {
        if (this.state.suchecked) {
            this.setState({
                sallowuser: []
            })
        }
        this.setState({
            suchecked: !this.state.suchecked
        });

    }
    uhandlecheck() {
        this.setState({
            uchecked: !this.state.uchecked
        })
    }
    handleKeyPress(event) {
        if (event.which === 32) {
            if (this.state.allowu !== null) {
                console.log(this.state.allowu);
                this.state.allowuser.push(this.state.allowu);
                this.setState({
                    allowu: ''
                })
            }
        }



    }
    shandleKeyPress(event) {
        if (event.which === 32) {
            if (this.state.sallowu !== null) {
                console.log(this.state.allowu);
                this.state.sallowuser.push(this.state.sallowu);
                this.setState({
                    sallowu: ''
                })
            }
        }



    }
    handleuserinp(event) {
        this.setState({
            allowu: event.target.value
        });
    }

    shandleuserinp(event) {
        this.setState({
            sallowu: event.target.value
        });
    }
    handleChange(event) {
        this.setState({
            [event.target.id]: event.target.value
        });
    }

    async schedule(event) {
        this.setState({
            loading: true,
            error: ''
        })

        event.preventDefault();
        if(this.state.stitle == null){
            this.setState({
                error: 'Please Type Meeting Title'
            })
        return;
        }
        if (this.state.tdate == this.state.ddate) {
            this.setState({
                today: true,
            })
        }
        if (this.state.schecked == true && this.state.suchecked) {
            if (this.state.srompwd == '' && !this.state.sallowuser.length) {
                console.log("Null")
                this.setState({
                    error: 'Please Type Password'
                })
            }
            else if (this.state.srompwd !== null && this.state.srompwd.length <= 8) {
                try {
                    this.setState({ error: '' })
                    const pushdb = db().ref('users/' + this.state.user.uid + '/scheduled/');

                    pushdb.push({
                        'id': this.state.id,
                        'auth': true,
                        'date': this.state.ddate,
                        'time': this.state.dtime,
                        'users': this.state.sallowuser,
                        allow: true,
                        status: 'PEND',
                        title: this.state.stitle,
                        'hname': this.state.user.displayName,
                        'pass': this.state.srompwd,
                        'host': this.state.user.uid,
                    }).then(() => {
                        this.setState({
                            loading: false,

                        });
                        message.success({
                            content: 'Your '+this.state.stitle+' is Successfully Scheduled',
                            duration: [3]
                        })
                        this.props.success();
                    })
                    console.log('Done');

                }
                catch (error) {
                    this.setState({
                        loading: false,
                        error: error.message
                    })
                }
            }
            else {
                this.setState({
                    error: 'Password Upto 8 char only'
                })

            }

        }
        else if (this.state.schecked == false && this.state.suchecked == true) {
            if (this.state.sallowuser !== null) {
                try {
                    this.setState({
                        error: ''
                    })
                    const pushdb = db().ref('users/' + this.state.user.uid + '/scheduled/');
                    pushdb.push({
                        id: this.state.id,
                        auth: false,
                        users: this.state.sallowuser,
                        time: this.state.dtime,
                        allow: true,
                        status: 'PEND',
                        title: this.state.stitle,
                        'hname': this.state.user.displayName,
                        date: this.state.ddate,
                        host: this.state.user.uid,
                    }).then(() => {
                        this.setState({
                            loading: false,

                        });
                        message.success({
                            content: 'Your '+this.state.stitle+' is Successfully Scheduled',
                            duration: [3]
                        })
                        this.props.success();
                    })
                    console.log('Done');



                }
                catch (error) {
                    this.setState({
                        error: error.message,
                        loading: false,
                    })
                }
            }
            else {
                this.setState({
                    error: "There is No Users added in Allowed User"
                })
            }



        }
        else if (this.state.schecked == true && this.state.suchecked == false) {
            if (this.state.srompwd !== null && this.state.srompwd.length <= 8) {
                try {
                    this.setState({
                        error: ''
                    })
                    const pushdb = db().ref('users/' + this.state.user.uid + '/scheduled/');
                    pushdb.push({
                        id: this.state.id,
                        auth: true,
                        time: this.state.dtime,
                        date: this.state.ddate,
                        status: 'PEND',
                        title: this.state.stitle,
                        'hname': this.state.user.displayName,
                        allow: false,
                        pass: this.state.srompwd,
                        host: this.state.user.uid,
                    }).then(() => {
                        this.setState({
                            loading: false,

                        });
                        message.success({
                            content: 'Your '+this.state.stitle+' is Successfully Scheduled',
                            duration: [3]
                        })
                       this.props.success();
                    })
                    console.log('Done');



                }
                catch (error) {
                    this.setState({
                        error: error.message,
                        loading: false,
                    })
                }
            }
            else {
                this.setState({
                    error: "Pass is More than 8"
                })
            }




        }
        else if (this.state.schecked == false && this.state.suchecked == false) {
            try {
                this.setState({
                    error: ''
                })
                const pushdb = db().ref('users/' + this.state.user.uid + '/scheduled/');
                pushdb.push({
                    id: this.state.id,
                    auth: false,
                    time: this.state.dtime,
                    date: this.state.ddate,
                    status: 'PEND',
                    title: this.state.stitle,
                    'hname': this.state.user.displayName,
                    allow: false,
                    host: this.state.user.uid,
                }).then(() => {
                    this.setState({
                        loading: false,

                    });
                    message.success({
                        content: 'Your '+this.state.stitle+' is Successfully Scheduled',
                        duration: [3]
                    })
                    this.props.success();
                })
                console.log('Done');



            }
            catch (error) {
                this.setState({
                    error: error.message,
                    loading: false,
                })
            }

        }
        else {
            this.setState({
                error: 'Somethinng wRONG'
            })
        }



        //   if(currentDate > this.state.ddate ){ 
        //       console.log('Past');
        //     }
        //   else if(currentDate < this.state.ddate){ 
        //       console.log('Future');
        //     }
        //   else if(currentDate == this.state.ddate) {
        //       console.log('Today');
        //       if(today_time > this.state.dtime){
        //           console.log('Past Time');
        //       }
        //       else if(today_time < this.state.dtime){
        //           console.log('There is Little Time');
        //       }
        //       else if(today_time == this.state.dtime){
        //           console.log('Now!');
        //       }
        //     }

    }


    async createnow(event) {
        event.preventDefault();
        this.setState({
            loading: true
        })
        if(this.state.title == ''){
            this.setState({
                error: 'Please Type Meeting Title',
                loading: false
            })
            return;
        }
        if (this.state.checked == true && this.state.uchecked) {
            if (this.state.rompwd == null && this.state.allowuser == null) {
                console.log("Null")
                this.setState({
                    error: 'Please Type Password',
                    loading: false,
                })
            }
            else if (this.state.rompwd && this.state.rompwd !== null && this.state.rompwd.length <= 8) {
                try {
                    this.setState({ error: '' })
                    const pushdb = db().ref('all-rooms/' + this.state.id);

                    pushdb.set({
                        'id': this.state.id,
                        'auth': true,
                        'users': this.state.allowuser,
                        allow: true,
                        status: 'ACTIVE',
                        title: this.state.title,
                        'hname': this.state.user.displayName,
                        'pass': this.state.rompwd,
                        'host': this.state.user.uid,
                    }).then(() => {
                        window.location.replace(`/room/${this.state.id}`);
                    });

                }
                catch (error) {
                    this.setState({
                        error: error.message,
                        loading: false,
                    })
                }
            }
            else {
                this.setState({
                    error: 'Password Upto 8 char only',
                    loading: false,
                })

            }

        }
        else if (this.state.checked == false && this.state.uchecked == true) {
            if (this.state.allowuser !== null) {
                try {
                    this.setState({
                        error: ''
                    })

                    const pushdb = db().ref('all-rooms/' + this.state.id);
                    pushdb.set({
                        id: this.state.id,
                        auth: false,
                        users: this.state.allowuser,
                        status: 'ACTIVE',
                        allow: true,
                        title: this.state.title,
                        'hname': this.state.user.displayName,
                        host: this.state.user.uid,
                    }).then(() => {
                        window.location.replace(`/room/${this.state.id}`);
                    })


                }
                catch (error) {
                    this.setState({
                        error: error.message,
                        loading: false,
                    })
                }

            }

        }
        else if (this.state.checked == true && this.state.uchecked == false) {
            if (this.state.rompwd == null) {
                console.log("Null")
                this.setState({
                    error: 'Please Type Password',
                    loading: false,
                })
            }
            else if (this.state.rompwd !== null && this.state.rompwd.length <= 8) {
                try {
                    this.setState({ error: '' })
                    const pushdb = db().ref('all-rooms/' + this.state.id);

                    pushdb.set({
                        'id': this.state.id,
                        'auth': true,
                        'pass': this.state.rompwd,
                        allow: false,
                        title: this.state.title,
                        status: 'ACTIVE',
                        'hname': this.state.user.displayName,
                        'host': this.state.user.uid,
                    }).then(() => {
                        window.location.replace(`/room/${this.state.id}`);
                    })

                }
                catch (error) {
                    this.setState({
                        error: error.message,
                        loading: false,
                    })
                }
            }
            else {
                this.setState({
                    error: 'Password Upto 8 char only'
                })

            }
        }
        else if (this.state.checked == false && this.state.uchecked == false) {
            try {
                this.setState({
                    error: ''
                })
                const pushdb = db().ref('all-rooms/' + this.state.id);
                pushdb.set({
                    id: this.state.id,
                    status: 'ACTIVE',
                    auth: false,
                    'hname': this.state.user.displayName,
                    allow: false,
                    title: this.state.title,
                    host: this.state.user.uid,
                }).then(() => {
                    window.location.replace(`/room/${this.state.id}`);
                })


            }
            catch (error) {
                this.setState({
                    error: error.message,
                    loading: false,
                })
            }


        }

        else {
            this.setState({
                error: 'Somethinng wRONG',
                loading: false,
            })
        }
    }

    copyCodeToClipboard = (option) => {
        const copykey = 'copy';
        if (option === 'scheduleId') {
            const el = this.scheduleId
            el.select();
            document.execCommand("copy");
            message.success({
                content: 'Your Meeting ID Was Succefully Copied',
                duration: [0.5],
                key: copykey,
            })
        } else {
            const meetid = this.meetingId
            meetid.select()
            document.execCommand("copy")
            message.success({
                content: 'Your Meeting ID was Successfully Copied',
                duration: [0.5],
                key: copykey,
            })
        }
    }

    render() {

        return (
            <Modal
                visible={this.props.visibility}
                onCancel={this.props.onClose}
                footer={null}
            >

                {/* <ProfileSection> */}
                {/* <Profile className='createRoom'> */}
                {this.state.loading ? <Loader />
                    :
                    <CreateRoomTab>
                        <Tabs defaultActiveKey="start_now" transition={false} id="noanim-tab-example">
                            <Tab eventKey="start_now" title="Start Now">
                                <Form onSubmit={e => {if(e.keyCode == 13) return false}} className="auth-form">
                                    <Form.Group>
                                        <Form.Label>Meeting Id</Form.Label>
                                        <div style={{ position: 'relative' }}>
                                            <Form.Control name="remail" readOnly value={this.state.id}
                                                id="romid" type="text" placeholder="Enter RoomID"
                                                style={{ paddingRight: '30px' }}
                                                ref={(meetingId) => this.meetingId = meetingId}
                                            />
                                            <FontAwesomeIcon className='fa-icon' icon={faCopy}
                                                onClick={() => this.copyCodeToClipboard('meetingId')}
                                                style={{
                                                    position: 'absolute',
                                                    right: '10px',
                                                    cursor: "pointer",
                                                    bottom: '13px',
                                                }} />
                                        </div>
                                    </Form.Group>
                                    <Form.Group>
                                    <Form.Label>Meeting Title</Form.Label>
                                    <Form.Control name='title' onChange={this.handleChange} id='title' value={this.state.title} placeholder='Enter meeting title' />
                                    </Form.Group>
                                    <Form.Group controlId="formGroupCheckbox">
                                        <Form.Check type="checkbox" defaultChecked={this.state.checked} onChange={this.handlecheck} label="Add password" />
                                    </Form.Group>
                                    {this.state.checked == true ?
                                        <Form.Group controlId="formGroupPassword">
                                            <Form.Label>Password</Form.Label>
                                            <Form.Control name="rompwd" onChange={this.handleChange} value={this.state.rompwd} id="rompwd" type="password" placeholder="Password" />
                                        </Form.Group> : <div></div>
                                    }
                                    <Form.Group controlId="formGroupEmail">
                                        <Form.Group controlId="formGroupChheckbox">
                                            <Form.Check type="checkbox" defaultChecked={this.state.uchecked} onChange={this.uhandlecheck} label="Allowed User" />
                                        </Form.Group>
                                        <text>{this.state.allowuser.map((i) => <li>{i}</li>)}</text>
                                    </Form.Group>

                                    {this.state.uchecked == true ?
                                        <Form.Group>
                                            <Form.Label>Users Allowed</Form.Label>
                                            <Form.Control name="allow-users" onKeyPress={this.handleKeyPress} onChange={this.handleuserinp} value={this.state.allowu} id="allow-users" type="text" placeholder="Enter the user email one by one"></Form.Control>

                                        </Form.Group> : <div></div>}
                                    {this.state.error ? <p className="text-danger">{this.state.error}</p> : null}
                                    <ModalButton onClick={this.createnow} variant="primary">Start meeting</ModalButton>


                                </Form>

                            </Tab>
                            <Tab eventKey="schedule" title="Schedule">
                                <Form onSubmit={e => {return e.key != 'Enter';}} className="schedule-form">
                                    <Form.Group controlId="romid">
                                        <Form.Label>Meeting Id</Form.Label>
                                        <div style={{ position: 'relative' }}>
                                            <Form.Control name="romid" readOnly value={this.state.id}
                                                ref={(scheduleId) => this.scheduleId = scheduleId}
                                                id="romid" type="text" placeholder="Enter RoomID" 
                                                style={{ paddingRight: '30px' }} />
                                                
                                            <FontAwesomeIcon className='fa-icon' icon={faCopy}
                                                onClick={() => this.copyCodeToClipboard('scheduleId')}
                                                style={{
                                                    position: 'absolute',
                                                    right: '10px',
                                                    bottom: '13px',
                                                    cursor: "pointer",
                                                }} />
                                        </div>
                                    </Form.Group>
                                    <Form.Group>
                                    <Form.Label>Meeting Title</Form.Label>
                                    <Form.Control name='stitle' id='stitle' onChange={this.handleChange} value={this.state.stitle} placeholder='Enter meeting title' />
                                    </Form.Group>

                                    <Form.Group controlId="datepicker">
                                        <Form.Group controlId="formGroupCheckbox">
                                            <Form.Check type="checkbox" defaultChecked={this.state.schecked} onChange={this.shandlecheck} label="Add password" />
                                        </Form.Group>
                                        {this.state.schecked == true ?
                                            <Form.Group controlId="formGroupPassword">
                                                <Form.Label>Password</Form.Label>
                                                <Form.Control name="srompwd" onChange={this.handleChange} value={this.state.srompwd} id="srompwd" type="password" placeholder="Password" />
                                            </Form.Group> : <div></div>
                                        }
                                        <Form.Group controlId="formGroupChheckbox">
                                            <Form.Check type="checkbox" defaultChecked={this.state.suchecked} onChange={this.suhandlecheck} label="Allowed User" />
                                        </Form.Group>
                                        <text>{this.state.sallowuser.map((i) => <li>{i}</li>)}</text>
                                        {this.state.suchecked == true ?
                                            <Form.Group>
                                                <Form.Label>Users Allowed</Form.Label>
                                                <Form.Control name="sallow-users" onKeyPress={this.shandleKeyPress} onChange={this.shandleuserinp} value={this.state.sallowu} id="sallow-users" type="text" placeholder="Enter the user email one by one"></Form.Control>
                                            </Form.Group> : <div></div>}
                                        {this.state.error ? <p className="text-danger">{this.state.error}</p> : null}
                                        <Form.Label>Date</Form.Label>
                                        <Form.Control min={this.state.tdate} name="ddate" id="ddate" type="date" max="2021-08-10" onChange={this.handleChange} value={this.state.ddate}></Form.Control>
                                        <Form.Control min={this.state.today ? this.state.ttime : ''} name="dtime" id="dtime" type="time" onChange={this.handleChange} value={this.state.dtime}></Form.Control>
                                    </Form.Group>
                                    <ModalButton onClick={this.schedule}>Schedule</ModalButton>
                                </Form>

                            </Tab>
                        </Tabs>
                    </CreateRoomTab>
                }
                {/* </Profile> */}
                {/* </ProfileSection> */}
            </Modal>
        );
    }
};